import React from "react";
import UploadHeader from "../components/common/UploadHeader";
import PostUploadForm from "../components/postUpload";

const PostUpload = () => {
  return (
    <>
      <UploadHeader />
      <PostUploadForm />
    </>
  );
};

export default PostUpload;
